import { Form, FormikProvider, useFormik } from "formik"
import NCModal from "../../shared/NCModal"
import { Grid } from "@material-ui/core"
import * as Yup from "yup"
import { useGetDispatchersList } from "../../services/queries"
import FormField from "../../components/FormField"
import NCAutocomplete from "../../shared/NCAutocomplete"
import NCButton from "../../shared/NCButton"
import { useQueryClient } from "react-query"
import { useReassignDispatcherToDriver } from "../../services/mutations"
import NCLoader from "../../shared/NCLoader"
import { toast } from "react-toastify"
import { useState } from "react"

const AddChangeDispatcherModal = ({
  driverId,
  selectedDispatcher,
  modalState = false,
  handleClose
}) => {
  const [search, setSearch] = useState(null)
  const { data, isLoading } = useGetDispatchersList(null, search)
  const reassignDispatcherApi = useReassignDispatcherToDriver()
  const queryClient = useQueryClient()
  const dispatcherList = data?.data?.data?.results || []

  const formik = useFormik({
    initialValues: {
      dispatcher: ""
    },
    validationSchema: Yup.object().shape({
      dispatcher: Yup.string().required("Dispatcher is required")
    }),
    enableReinitialize: true,
    onSubmit: values => {
      reassignDispatcherApi.mutate(
        { ...values, id: driverId },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(["getDriverDetail"])
            queryClient.invalidateQueries(["getDriverList"])
            toast.success("Dispatcher updated successfully")
            handleClose()
          },
          onError: error => {
            toast.error(error?.response?.data || "Failed to update dispatcher")
          }
        }
      )
    }
  })

  const changeModal = (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormField
              as={NCAutocomplete}
              options={dispatcherList || []}
              label="Dispatcher"
              name="dispatcher"
              onChange={v => formik.setFieldValue("dispatcher", v)}
              onSearch={v => setSearch(v)}
              loading={isLoading}
              required={true}
              error={formik?.errors?.dispatcher}
            />
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  )

  return (
    <>
      <NCModal
        open={modalState}
        title={selectedDispatcher ? "Change Dispatcher" : "Assign Dispatcher"}
        text={changeModal}
        onClose={() => handleClose()}
        size={"lg"}
        submitButton={
          <NCButton
            variant="contained"
            color="primary"
            disableElevation
            disabled={reassignDispatcherApi.isLoading}
            onClick={formik.handleSubmit}
            style={{ width: "auto" }}
          >
            {reassignDispatcherApi.isLoading
              ? "Updating..."
              : selectedDispatcher
              ? "Change Dispatcher"
              : "Assign Dispatcher"}
          </NCButton>
        }
      />
      {reassignDispatcherApi.isLoading && <NCLoader open={true} />}
    </>
  )
}

export default AddChangeDispatcherModal
